
















































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  TriageObservationFile,
  TriageSubstanceAdministration,
} from "@/types/aznconnect_api";
import InformationCard from "@/components/InformationCard.vue";

@Component({
  components: {
    "information-card": InformationCard,
  },
})
export default class PrescribedMedicationView extends Vue {
  @Prop()
  advancedMode!: boolean;

  @Prop({ default: null })
  title!: string;

  @Prop({ default: null })
  observationFile!: TriageObservationFile;

  get medicijnColumnClass(): string {
    return this.advancedMode ? "text-value-18-width" : "text-value-23-width";
  }

  formatPrescriberName(
    substanceAdministration: TriageSubstanceAdministration,
  ): string {
    const name = substanceAdministration.PrescriberName;
    const uziCode = substanceAdministration.PrescriberUziCode;

    if (!name && !uziCode) return "-";
    if (!name) return uziCode;
    if (!uziCode) return name;

    return `${name} (${uziCode})`;
  }

  formatPrescriptionReason(
    substanceAdministration: TriageSubstanceAdministration,
  ): string {
    const displayValue =
      substanceAdministration.PrescriptionReasonValueDisplayValue || "-";
    const code = substanceAdministration.PrescriptionReasonValueCode;

    if (!code || !this.advancedMode) {
      return displayValue;
    }

    return `${displayValue} (${code})`;
  }
}
